import React from 'react';

interface Props {
  children: React.ReactNode;
}

export const OutputWidgetBlock: React.FC<Props> = ({ children }) => (
  <div className="my-2 rounded-lg border border-gray-200 dark:border-medical-600 overflow-hidden">
    {children}
  </div>
);
